import { defineStore } from "pinia";

export const useCatalogStore = defineStore('catalog', {
    state: () => ({
        catalog: {},
        catalogs: [],
    }),
    actions: {
        setCatalog(catalog) {
            this.catalog = catalog
        },
        setCatalogs(catalogs) {
            this.catalogs = catalogs
        },
        addCatalog(catalog) {
            this.catalogs.unshift(catalog)
        },
        updateCatalog(catalog) {
            let index = this.catalogs.findIndex(cl => cl.id === catalog.id)
            this.catalogs.splice(index, 1, catalog)
        },
        deleteCatalog(catalog) {
            let index = this.catalogs.findIndex(cl => cl.id === catalog.id)
            this.catalogs.splice(index, 1)
        },
    },
});